import { render, staticRenderFns } from "./DoctorsSelectbox.vue?vue&type=template&id=548a8278"
import script from "./DoctorsSelectbox.vue?vue&type=script&lang=js"
export * from "./DoctorsSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports